'use client'

import { createContext, PropsWithChildren, useContext, useState } from 'react'

type LikeState = {
  like: boolean
  toggleLike: () => void
}

const LikeContext = createContext<LikeState | null>(null)

type Props = {
  like?: boolean
}

export const LikeProvider = ({
  like: likeProp = false,
  children,
}: PropsWithChildren<Props>) => {
  const [like, setLike] = useState<boolean>(likeProp)

  const toggleLike = () => {
    setLike(prev => !prev)
  }

  return (
    <LikeContext.Provider value={{ like, toggleLike }}>
      {children}
    </LikeContext.Provider>
  )
}

export const useLike = () => {
  const context = useContext(LikeContext)

  return context
}
